import { render, staticRenderFns } from "./VisualizarHabilidadeDialog.vue?vue&type=template&id=b02f013a"
import script from "./VisualizarHabilidadeDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarHabilidadeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports